export default __webpack_public_path__ + "b12b0a96706eabf6f20d0492daa55f78.png";